import { z } from 'zod'

export const UNAUTHENTICATED_USER_ID = 'unauthenticated_user'

// TODO: sort this location, move the old out of api-shared
const UserIdSchema = z.string().max(20) // TODO: do we have more specifics on what this can be? For BA 8 digits, for EI 16 digits (in stage auth)

export const getMembershipIdFromSub = (userSub: string) => {
  if (!userSub.startsWith('auth0|')) {
    throw new Error('Invalid user token')
  }

  const userSubParts = userSub.split('|')

  return UserIdSchema.parse(userSubParts[1])
}
